import {
  AclEntity,
  CapacityProviderType,
  CarrierRef,
  DomainBrandingSignedDocumentReference,
  EquipmentType,
  ICarrier,
  InsuranceInformation,
  OperatingStatus,
  SafetyRating,
  ServiceLevel,
} from '@rygen/rygen-ui/model';
import { Mode } from '@rygen/rygen-ui/model/Mode';

export class Carrier extends AclEntity implements ICarrier {
  id?: number;
  name?: string;
  scac?: string;
  dotNumber?: string;
  mcNumber?: string;
  cvorNumber?: string;
  modes: Mode[] = [];
  equipmentTypes: EquipmentType[] = [];
  serviceLevels: ServiceLevel[] = [];
  active = true;
  manifestingEnabled = false;
  type = CapacityProviderType.CARRIER;
  logo?: DomainBrandingSignedDocumentReference;
  dotSafetyRating?: SafetyRating;
  commonAuthority?: OperatingStatus;
  brokerAuthority?: OperatingStatus;
  contractAuthority?: OperatingStatus;
  insuranceInformation: InsuranceInformation = new InsuranceInformation();

  constructor(opts?: Partial<Carrier>) {
    super(opts);
    if (opts?.id != null) {
      this.id = opts.id;
    }
    if (opts?.name != null) {
      this.name = opts.name;
    }
    if (opts?.scac != null) {
      this.scac = opts.scac;
    }
    if (opts?.dotNumber != null) {
      this.dotNumber = opts.dotNumber;
    }
    if (opts?.mcNumber != null) {
      this.mcNumber = opts.mcNumber;
    }
    if (opts?.cvorNumber != null) {
      this.cvorNumber = opts.cvorNumber;
    }
    if (opts?.modes != null) {
      this.modes = opts.modes.map((val) => {
        if (typeof val === 'string') {
          return Mode[val];
        }
        return val;
      });
    }
    if (opts?.equipmentTypes != null) {
      this.equipmentTypes = opts.equipmentTypes.map(
        (val) => new EquipmentType(val),
      );
    }
    if (opts?.serviceLevels != null) {
      this.serviceLevels = opts.serviceLevels.map(
        (val) => new ServiceLevel(val),
      );
    }
    if (opts?.active != null) {
      this.active = opts.active;
    }
    if (opts?.manifestingEnabled != null) {
      this.manifestingEnabled = opts.manifestingEnabled;
    }
    if (typeof opts?.type === 'string') {
      this.type = CapacityProviderType[opts.type];
    } else if (opts?.type != null) {
      this.type = opts.type;
    }
    if (opts?.logo != null) {
      this.logo = new DomainBrandingSignedDocumentReference(opts.logo);
    }
    if (opts?.dotSafetyRating != null) {
      this.dotSafetyRating = opts.dotSafetyRating;
    }
    if (opts?.commonAuthority != null) {
      this.commonAuthority = opts.commonAuthority;
    }
    if (opts?.brokerAuthority != null) {
      this.brokerAuthority = opts.brokerAuthority;
    }
    if (opts?.contractAuthority != null) {
      this.contractAuthority = opts.contractAuthority;
    }
    if (opts?.insuranceInformation != null) {
      this.insuranceInformation = new InsuranceInformation(
        opts.insuranceInformation,
      );
    }
  }

  static fromCarrierRef(carrierRef: CarrierRef): Carrier {
    return new Carrier({
      id: carrierRef.carrierId,
      name: carrierRef.name,
      scac: carrierRef.scac,
      mcNumber: carrierRef.mcNumber,
      type: carrierRef.type,
    });
  }

  toCarrierRef(): CarrierRef {
    return new CarrierRef({
      carrierId: this.id,
      name: this.name,
      scac: this.scac,
      mcNumber: this.mcNumber,
      type: this.type,
    });
  }
}
